const getChannelsConnected = (channels) => (channel) =>
  channels[channel].status != 'disconnected';
const mountArrayChannels = (channelsConnected, channel) =>
  channelsConnected.concat(channel);

const sumOnHoldAttendances = (onHold) =>
  Object.entries(onHold).reduce((previusValue, entrie) => {
    const [, onHoldAttendances] = entrie;
    return previusValue + onHoldAttendances;
  }, 0);

const getters = {
  amountChannelsInPause(state) {
    let amount = 0;
    Object.keys(state.channels).forEach((channel) => {
      if (
        state.channels[channel].status == 'paused' ||
        state.channels[channel].status == 'scheduled_pause'
      ) {
        amount++;
      }
    });
    return amount;
  },

  connectedInWhatsapp(state) {
    return (
      state.channels.whatsapp.status &&
      state.channels.whatsapp.status != 'disconnected'
    );
  },

  connectedInVoice(state) {
    return (
      state.channels.voice.status &&
      state.channels.voice.status != 'disconnected'
    );
  },

  onHold(state) {
    const { channels } = state;

    return Object.keys(channels)
      .filter(getChannelsConnected(channels))
      .reduce((previusValue, channel) => {
        const { onHold } = channels[channel];
        previusValue[channel] = sumOnHoldAttendances(onHold);
        return previusValue;
      }, {});
  },

  channelsConnected(state) {
    const { channels } = state;

    const channelsForDisconnection = Object.keys(channels)
      .filter(getChannelsConnected(channels))
      .reduce(mountArrayChannels, []);

    if ('chatVisor' in state && state.chatVisor) {
      channelsForDisconnection.push('chatVisor');
    }

    return channelsForDisconnection;
  },

  channels(state) {
    const channels = Object.entries(state.channels).map(
      ([channel, { status }]) => {
        return { channel, status };
      },
    );

    return channels;
  },

  unavailableForAttendance(state, getters) {
    const { channels } = getters;
    const unavailableStatus = ['disconnected', 'paused'];

    const checkingUnavailableStatus = ({ status }) =>
      unavailableStatus.includes(status);
    const isUnavailable = (unavailable) => unavailable;

    const unavailable = channels
      .map(checkingUnavailableStatus)
      .every(isUnavailable);

    return unavailable;
  },
};

export default getters;
